import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import AdsList from "./AdsList";

import { observer } from "mobx-react";

class Ads extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    UNSAFE_componentWillMount() {
        this.props.store.setCurrentSection("ads");

        // Breadcrumbs
        this.props.store.setBreadcrumbs([{ title: "Ads" }]);
    }

    render() {
        return (
            <Switch>
                {/* <Route
                    path="/dashboard/competitors/:id/report"
                    //   render={props => (
                    //       // <CompetitorsReport
                    //       //     store={this.props.store}
                    //       //     {...props}
                    //       // />
                    //   )}
                /> */}
                <Route
                    render={props => (
                        <AdsList store={this.props.store} {...props} />
                    )}
                />
            </Switch>
        );
    }
}

export default observer(Ads);
